var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "category-edit" } },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/goodsList" } } },
                [_c("div", { staticClass: "div1" }, [_vm._v("商品列表")])]
              ),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("新增商品")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("数据筛选")]),
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, id: "searchForm", model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "类目", prop: "categoryId" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      "popper-class": "search-category",
                      placeholder: "请输入商品类目",
                      options: _vm.categoryList,
                      "show-all-levels": true,
                      size: "mini",
                      filterable: "",
                      clearable: "",
                    },
                    on: { change: _vm.onChangeCategory },
                    model: {
                      value: _vm.categoryId,
                      callback: function ($$v) {
                        _vm.categoryId = $$v
                      },
                      expression: "categoryId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("h3", [_vm._v("选择商品分类")]),
          _vm.categoryId && _vm.categoryId.length !== 0
            ? _c(
                "div",
                { staticClass: "show-category", attrs: { title: "展示" } },
                [
                  _c("span", [_vm._v("已选择：")]),
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.categoryList,
                      disabled: true,
                      separator: " > ",
                    },
                    model: {
                      value: _vm.categoryId,
                      callback: function ($$v) {
                        _vm.categoryId = $$v
                      },
                      expression: "categoryId",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("el-cascader-panel", {
            attrs: { options: _vm.categoryList },
            model: {
              value: _vm.categoryId,
              callback: function ($$v) {
                _vm.categoryId = $$v
              },
              expression: "categoryId",
            },
          }),
          _c(
            "div",
            { staticClass: "step" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "warning",
                    disabled:
                      _vm.categoryId && _vm.categoryId.length !== 0
                        ? false
                        : true,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.checkUpAttrDataList(
                        "goodsAdd",
                        _vm.categoryId,
                        "category"
                      )
                    },
                  },
                },
                [_vm._v("下一步")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }